var map = {
	"./1.jpeg": 9457,
	"./2.jpeg": 6259,
	"./3.jpeg": 9820,
	"./4.jpeg": 1172,
	"./5.jpeg": 4324,
	"./6.jpeg": 4128,
	"./7.jpeg": 8961,
	"./8.jpeg": 1413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6536;